import i18n from '@/i18n'

export const durationMs = {
  second: 1000,
  minute: 60000,
  hour: 3600000,
  day: 86400000,
}

class Formatter {
  static vliveFormat(x: number) {
    if (x >= 1000000000000) {
      return i18n.t('formatUncountable')
    } else if (x >= 10000) {
      return this.ChineseNumeral(x)
    } else {
      return this.numberWithCommas(x)
    }
  }

  static ChineseNumeral(x: number) {
    const a = {
      num: 100000000,
      unit: '億',
    }
    const b = {
      num: 10000,
      unit: '万',
    }
    let c = b

    if (x >= a.num) {
      c = a
    }

    return String(Math.floor((x * 10) / c.num) / 10) + c.unit
  }

  static numberWithCommas(x: number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  /**
   * 期間表記
   *
   * 24時間以上=「N日」 ex. 25時間なら「1日」
   * 24時間未満=「H時間M分S秒」「M分S秒」「S秒」
   * @param duration
   */
  static duration(duration: number) {
    const second = Math.floor(
      (duration % durationMs.minute) / durationMs.second
    )
    if (duration < durationMs.minute)
      return i18n.t('durationFormat1', { second })
    const minute = Math.floor((duration % durationMs.hour) / durationMs.minute)
    if (duration < durationMs.hour)
      return i18n.t('durationFormat2', { minute, second })
    const hour = Math.floor((duration % durationMs.day) / durationMs.hour)
    if (duration < durationMs.day)
      return i18n.t('durationFormat3', { hour, minute, second })
    const day = Math.floor(duration / durationMs.day)
    return i18n.t('durationFormat4', { day, hour, minute, second })
  }

  // 桁ずらし
  // cf. https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Math/round#A_better_solution
  static shift(number: number, precision: number, reverseShift: boolean) {
    if (reverseShift) {
      precision = -precision
    }
    const numArray = ('' + number).split('e')
    return +(
      numArray[0] +
      'e' +
      (numArray[1] ? +numArray[1] + precision : precision)
    )
  }

  /**
   * 浮動小数点の誤差問題を回避する桁round
   *
   * cf. https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Math/round#A_better_solution
   * @param number 数
   * @param precision 桁
   */
  static round(number: number, precision: number) {
    return this.shift(
      Math.round(this.shift(number, precision, false)),
      precision,
      true
    )
  }

  /**
   * 浮動小数点の誤差問題を回避するtoFixed
   * @param number 数
   * @param precision 桁
   */
  static toFixed(value: number, precision: number) {
    return this.round(value, precision).toFixed(precision)
  }
}

export default Formatter
